<template>
  <div class="index-fee-card">
    <div class="card-title">{{ $t('propertyIndex.feeSummary') }}</div>
    <el-row :gutter="16" class="fee-cards">
      <el-col :span="6" v-for="(card, idx) in feeCards" :key="idx">
        <div class="fee-stat" :style="{ borderLeft: `3px solid ${card.color}` }">
          <div class="fee-stat-label">{{ $t(`propertyIndex.${card.label}`) }}</div>
          <div class="fee-stat-value" :style="{ color: card.color }">{{ card.value }}</div>
          <div class="fee-stat-sub">{{ $t(`propertyIndex.${card.sub}`) }}</div>
        </div>
      </el-col>
    </el-row>
    <el-table :data="[feeRow]" border size="small" class="fee-table">
      <el-table-column prop="monthReceivable" :label="$t('propertyIndex.monthReceivable')" align="center" />
      <el-table-column prop="monthReceived" :label="$t('propertyIndex.monthReceived')" align="center" />
      <el-table-column prop="monthPayCount" :label="$t('propertyIndex.monthPayCount')" align="center" />
      <el-table-column prop="collectionRate" :label="$t('propertyIndex.collectionRate')" align="center" />
    </el-table>
  </div>
</template>

<script>
import { getFeeIndex } from '@/api/index/propertyIndexApi'

export default {
  name: 'IndexFeeSummary',
  data() {
    return {
      feeIndexInfo: {
        activeFeeCount: 0,
        finishedFeeCount: 0,
        monthReceivable: '0.00',
        monthReceived: '0.00',
        yearReceived: '0.00',
        monthPayCount: 0
      }
    }
  },
  computed: {
    feeCards() {
      return [
        { label: 'activeFee', value: this.feeIndexInfo.activeFeeCount, sub: 'activeFeeSub', color: '#4B7AF0' },
        { label: 'finishedFee', value: this.feeIndexInfo.finishedFeeCount, sub: 'finishedFeeSub', color: '#8B5CF6' },
        { label: 'monthReceivedAmt', value: '¥' + this.feeIndexInfo.monthReceived, sub: 'monthReceivedSub', color: '#01C36D' },
        { label: 'yearReceivedAmt', value: '¥' + this.feeIndexInfo.yearReceived, sub: 'yearReceivedSub', color: '#F59E0B' }
      ]
    },
    feeRow() {
      const receivable = parseFloat(this.feeIndexInfo.monthReceivable) || 0
      const received = parseFloat(this.feeIndexInfo.monthReceived) || 0
      const rate = receivable > 0 ? (received / receivable * 100).toFixed(2) + '%' : '0%'
      return {
        monthReceivable: '¥' + this.feeIndexInfo.monthReceivable,
        monthReceived: '¥' + this.feeIndexInfo.monthReceived,
        monthPayCount: this.feeIndexInfo.monthPayCount + ' ' + this.$t('propertyIndex.payCountUnit'),
        collectionRate: rate
      }
    }
  },
  methods: {
    async _loadFeeIndexData() {
      try {
        const res = await getFeeIndex({ page: 1, row: 10, communityId: this.getCommunityId() })
        Object.assign(this.feeIndexInfo, res.data)
      } catch (error) {
        console.error('查询收费指标失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.index-fee-card {
  background: #fff;
  border-radius: 4px;
  padding: 15px;

  .card-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
  }

  .fee-cards {
    margin-bottom: 16px;

    .fee-stat {
      background: #FAFBFC;
      border-radius: 4px;
      padding: 14px 16px;
      transition: box-shadow 0.2s;

      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      }

      .fee-stat-label {
        font-size: 12px;
        color: #999;
        margin-bottom: 6px;
      }

      .fee-stat-value {
        font-size: 22px;
        font-weight: 700;
        line-height: 1.3;
      }

      .fee-stat-sub {
        font-size: 11px;
        color: #bbb;
        margin-top: 4px;
      }
    }
  }

  .fee-table {
    width: 100%;
  }
}
</style>
